import React from 'react'
import Popup from './Popup';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import ErrorBoundary from './ErrorBoundary';
import db from './db';
var functions = require("./functions.js");

// BeaconHistoryPopup component
export default class BeaconHistoryPopup extends React.Component {

// initialize the BeaconHistoryPopup Component
constructor(props) {
    super(props);
    this.state = {
        beacons:[],
        lastBeacons:""
    };
}

    // render
    render() {
        if(this.props.beaconPair &&
            this.state.lastBeacons!==this.props.beaconPair.left_mac_address+this.props.beaconPair.right_mac_address
            ){
            db.getBeaconHistory( this.props.beaconPair.left_mac_address
                                , this.props.beaconPair.right_mac_address
                                , this.props.securityObject
                                , (beaconList) => { 
                                    let newList=[];
                                    let last="";
                                    beaconList.forEach(beacon=>{
                                        if(last!==beacon.device_name){
                                            newList.push({"device_name":beacon.device_name});
                                        }
                                        newList.push(beacon);
                                        last=beacon.device_name;
                                    })
                                    this.setState({
                                        beacons : newList,
                                        lastBeacons:this.props.beaconPair.left_mac_address+this.props.beaconPair.right_mac_address
                                    })
                                })
        }        
        let hostnames="";
        try{
            hostnames=this.props.beaconPair.hostnames;
        } catch (ex){}
        let display_names="";
        try{
            display_names=this.props.beaconPair.display_names;
        } catch (ex){}        
        return(true) ? (
            <Popup className="beacon-history-popup" trigger={ this.props.beaconPair }  >
                <div className="align-right">
                    <button className="close-btn" onClick={() => this.props.closeBeaconHistoryPopup() }>Close</button>
                </div>
                <h3>Beacon History</h3>
                Hostnames:{hostnames}<br />
                Name:{display_names}<br />
                <TableScrollbar height="300px">
                    <ErrorBoundary>
                            <Table columns={[
                                        { title: 'id', key: 'beacon_history_id', width :5 }
                                        ,{ title:'beacon id', key: 'beacon_id', width :5 }
                                        ,{ title:'mac address', key: 'mac_address', width :10 }
                                        ,{ title:'barcode', key: 'barcode', width :5 }
                                        ,{ title:'major', key: 'major', width :5 }
                                        ,{ title:'minor', key: 'minor', width :5 }
                                        ,{ title:'device name', key: 'device_name', width :5 }
                                        ,{ title:'uuid', key: 'uuid', width :10 }
                                        ,{ title:'original major', key: 'original_major', width :5 }
                                        ,{ title:'original minor', key: 'original_minor', width :5 }
                                        ,{ title:'created date', key: 'created_date', width :10, render:functions.renderDateInTable }
                                        ,{ title:'last updated', key: 'last_updated', width :10, render:functions.renderDateInTable }
                                        ,{ title:'firmware version', key: 'firmware_version', width :15 }
                                        ,{ title:'milli volts', key: 'milli_volts', width :5 }
                                        ,{ title:'countdown behavior', key: 'countdown_behavior', width :5 }
                                        ]} 
                                        dataSource={this.state.beacons} />
                    </ErrorBoundary>
                </TableScrollbar>
            </Popup>  
        ):"";
    }
}

